/**
 * Gerenciador de cache para consultas de operadora
 * TTL: 30 dias
 */

const CACHE_PREFIX = 'phone-operator-cache:';
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 dias

interface CacheEntry {
  operadora: string;
  timestamp: number;
  ttl: number;
}

export const phoneOperatorCache = {
  get(phone: string): string | null {
    try {
      const key = CACHE_PREFIX + phone;
      const raw = localStorage.getItem(key);
      if (!raw) return null;

      const entry: CacheEntry = JSON.parse(raw);
      const now = Date.now();

      // Verificar se expirou
      if (now - entry.timestamp > entry.ttl) {
        localStorage.removeItem(key);
        return null;
      }

      return entry.operadora;
    } catch (error) {
      console.error('Erro ao ler cache de operadora:', error);
      return null;
    }
  },

  set(phone: string, operadora: string): void {
    try {
      const key = CACHE_PREFIX + phone;
      const entry: CacheEntry = {
        operadora,
        timestamp: Date.now(),
        ttl: TTL_MS,
      };
      localStorage.setItem(key, JSON.stringify(entry));
    } catch (error) {
      console.error('Erro ao salvar cache de operadora:', error);
    }
  },

  clear(phone?: string): void {
    try {
      if (phone) {
        localStorage.removeItem(CACHE_PREFIX + phone);
      } else {
        // Limpar todos os caches de operadora
        const keys = Object.keys(localStorage);
        keys.forEach((key) => {
          if (key.startsWith(CACHE_PREFIX)) {
            localStorage.removeItem(key);
          }
        });
      }
    } catch (error) {
      console.error('Erro ao limpar cache de operadora:', error);
    }
  },
};
